import api from './axiosInstance';

export const taskApi = {
  getTaskList: (params = {}) => api.get('/tasks', {params}),
  assignWorker: (taskId, workerId) => api.post(`/tasks/${taskId}/assign`, {workerId}),
  startTask: taskId => api.post(`/tasks/${taskId}/start`),
  completeTask: (taskId, comments) => api.post(`/tasks/${taskId}/complete`, {comments}),
  cancelTask: taskId => api.post(`/tasks/${taskId}/cancel`),
};
